<template>
  <div>
    <div class="payment-methods">
      <div class="d-none" v-html="stringHtml"></div>
      <div class="d-flex align-items-center mt-2">
        <img src="@/assets/images/big_tick.svg" width="50" alt />
        <h5 class="text-success fw-normal mt-1 ml-3">
          Return Processed Successfully!
        </h5>
      </div>
      <div class="clearfix"></div>
      <h6 class="mt-3 fw-normal">Customer Information</h6>
      <hr class="my-2" />
      <b-row>
        <b-col md="4">
          <label>Name</label>
          <p v-text="returnData.customer_name" />
        </b-col>
        <b-col md="4">
          <label>Phone Number</label>
          <p v-text="returnData.customer_mobile" />
        </b-col>
      </b-row>
      <h6 class="mt-2 fw-normal">Invoice Details</h6>
      <hr class="my-2" />
      <b-row>
        <b-col md="4">
          <label>Invoice Number</label>
          <!-- <p v-if="returnData.invoice != ''">{{returnData.invoice}}</p>
          <p v-else>Not Available</p>-->
          <p v-text="returnData.invoice_id" />
        </b-col>
        <b-col md="4">
          <label>Date</label>
          <p>
            {{ returnData.data.created_at | moment("DD MMMM YYYY h:mm A") }}
          </p>
        </b-col>
        <b-col md="4">
          <!-- <label>Store</label> -->
          <!-- <p>-</p> -->
          <!-- <p v-if="returnData.customer_mobile != ''">{{returnData.customer_mobile}}</p> -->
        </b-col>
        <b-col md="12">
          <label>Return Remark</label>
          <p v-if="state.billing.billing.return_flow.remarks == ''">NA</p>
          <p v-else v-text="state.billing.billing.return_flow.remarks" />
          <p></p>
        </b-col>
      </b-row>

      <h6 class="fw-normal mt-2">Refund Summary</h6>
      <hr class="my-2" />
      <b-row>
        <b-col md="4">
          <label for>Total Amount</label>
          <p v-text="currencySymbol + formatAmount(returnData.data.total)" />
        </b-col>
        <b-col md="4">
          <label for>Refund Mode</label>
          <p v-text="returnData.refund_mode" />
        </b-col>
      </b-row>
    </div>
    <div class="customer-info mt-5">
      <b-row>
        <!-- <b-col md="3">
          <button class="btn btn-theme btn-lg btn-block mt-4 mt-md-2" @click="newBill">New Bill</button>
        </b-col>
        <b-col md="3">
          <button class="btn btn-theme btn-lg btn-block mt-4 mt-md-2">E-mail Invoice</button>
        </b-col>
        <b-col md="3">
          <button class="btn btn-theme btn-lg btn-block mt-4 mt-md-2">SMS Invoice</button>
        </b-col>-->
        <b-col md="3">
          <b-button
            :disabled="onePrintOnly"
            block
            variant="primary"
            class="mt-4 mt-md-2"
            @click="openPrintModal()"
            id="open-print-modal"
          >
            Print Return Invoice
          </b-button>
        </b-col>
      </b-row>
    </div>
    <!-- Cash Modal -->
    <b-modal
      ref="print-invoice-modal"
      hide-header
      hide-footer
      centered
      :size="printSize == 'A4' ? 'xl' : ''"
    >
      <div class="modal-head" style="border-bottom: 1px #c0c0c0 solid;">
        <b-row class="pb-3 print_box">
          <b-col>
            <h3 class="modal-title">Invoice Print</h3>
          </b-col>
          <b-col>
            <b-button
              class="float-right grey-btn"
              @click="printInvoice"
              :disabled="printBtn"
              id="print"
              >Print</b-button
            >
            <b-button
              style="margin-right:10px;"
              class="float-right grey-outline-btn"
              @click="hidePrintModal"
              id="close"
              >Close</b-button
            >
          </b-col>
        </b-row>
      </div>
      <div id="cool">
        <print-box :data="html" :print_type="'print'" />
        <!-- <iframe
          id="printf"
          name="printf"
          class="print-content"
          :src="this.html"
          style="height: 100vh; width:100%"
          frameborder="0"
        ></iframe>-->
        <!-- <b-embed
          name="print-invoice"
          type="iframe"
          aspect="16by9"
          :src="this.state.billing.invoice.print_url"
          allowfullscreen
        ></b-embed>-->
      </div>
      <!-- <template slot="modal-footer" cente>
        <b-button variant="success" size="lg" @click="printInvoice">Print</b-button>
          <b-button variant="danger" @click="hidePrintModal">Cancel</b-button>
      </template>-->
    </b-modal>
  </div>
</template>
<script>
// import VSelect from "@alfsnd/vue-bootstrap-select";
import { mapState } from "vuex";
import axios from "axios";
import PrintBox from "../components/PrintBox";
import qz from "../printer";
import * as msg from "../message";
export default {
  name: "return-done",
  components: {
    // VSelect,
    PrintBox,
  },
  props: ["data"],
  data() {
    return {
      Title: "Product Name & Description (Barcode)",
      html: "",
      printBtn: false,
      changeData: customData,
      stringHtml: "",
      onePrintOnly: false,
    };
  },
  watch: {
    changeData: {
      handler(val) {
        let self = this;
        console.log("In Data");
        if (val.data.type == "print_return_invoice") {
          if (val.data.status == "success") {
            self.printBtn = true;
            console.log("Change Data");
          }
        }
        if (val.data.type == "session_timeout") {
          console.log("Login Expire");
          let errorData = {
            msg: msg.LOGIN_REDIRECT,
            btntext: "Login",
            type: "logout",
          };
          this.$store.commit("notifications/showMessage", errorData);
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    returnData() {
      return this.state.billing.billing.return_flow.return_invoice;
    },
    printSize() {
      let size = 80;
      this.state.system.settings.print.map((item) => {
        if (item.name == "bill_print") {
          size = item.width;
        }
      });
      return size;
    },
    billLogo() {
      return this.$store.getters["system/billLogo"];
    },
    qrCode() {
      return this.$store.getters["system/qrCode"];
    },
  },
  mounted() {
    this.$store.commit("billing/setInvoiceDetails", {
      invoice_no: this.returnData.invoice_id,
      amount: this.returnData.data.total,
    });
    if (this.state.billing.auto_print == 1) {
      this.openPrintModal();
      this.$store.commit("billing/printMode", 0);
    }
  },
  beforeDestroy() {
    this.$store.commit("billing/clearReturnData");
    this.$store.commit("billing/clearInvoiceDetails");
  },
  methods: {
    newBill() {
      this.$store.dispatch("newBill");
      this.$router.push("billing");
    },
    openPrintModal() {
      this.$loading = true;
      if (typeof Android !== "undefined" && Android !== null) {
        let invoiceData = {
          v_id: this.state.sessions.user.v_id,
          store_id: this.state.sessions.store_id,
          vu_id: this.state.sessions.user.vu_id,
          trans_from: this.state.trans_from,
          api_token: this.state.billing.billing.return_flow.customer_info
            .api_token,
          c_id: this.state.billing.billing.return_flow.customer_info.c_id,
          order_id: this.state.billing.billing.return_flow.return_invoice
            .invoice_id,
          manufacturer_name: this.state.system.device_name,
          terminal_id: this.state.system.settings.terminal_id,
          url: "get-print-receipt",
        };
        // let data = Object.assign(invoiceData, this.customerData);
        axios.post(invoiceData.url, invoiceData).then((res) => {
          this.$loading = false;
          // console.log(res.data.print_data);
          let postData = {
            type: "print_return_invoice",
            data: res.data.print_data,
          };
          returnValue(postData);
        });
        // console.log(data);
      } else {
        let manuName = "";
        if (this.state.system.printer != "") {
          manuName = this.state.system.printer;
        }
        let invoiceData = {
          v_id: this.state.sessions.user.v_id,
          store_id: this.state.sessions.user.store_id,
          vu_id: this.state.sessions.user.vu_id,
          trans_from: this.state.system.trans_from,
          api_token: this.state.billing.billing.return_flow.customer_info
            .api_token,
          c_id: this.state.billing.billing.return_flow.customer_info.c_id,
          order_id: this.state.billing.billing.return_flow.return_invoice
            .invoice_id,
          // manufacturer_name: this.state.system.device_name,
          terminal_id: this.state.system.settings.terminal_id,
          url: "get-print-receipt",
          manufacturer_name: manuName,
        };
        // let data = Object.assign(invoiceData, this.customerData);
        axios.post(invoiceData.url, invoiceData).then((res) => {
          this.$loading = false;
          // console.log(res.data.print_data);
          // let postData = {
          //   type: "print_return_invoice",
          //   data: res.data.print_data
          // };
          // returnValue(postData);
          if (this.state.system.printer != "" && qz.websocket.isActive()) {
            // this.printHtml(
            //   this.state.return_flow.return_invoice.data.html_data
            // );
            if (this.printSize != "A4") {
              this.stringHtml = res.data.print_data
                .replace(
                  /<size=24>|<bold>|<\/bold>|<\/size>|<normal>|<\/normal>/gi,
                  ""
                )
                .replace(/<center>/gi, "<div class='cool-center'>")
                .replace(/<left>/gi, "<div class='cool-left'>")
                .replace(/<right>/gi, "<div class='cool-right'>")
                .replace(/<text>/gi, "<span>")
                .replace(/<\/text>/gi, "</span>")
                .replace(/<\/center>|<\/left>|<\/right>/gi, "</div>");
              this.stringHtml =
                "<div class='webpos-print'>" + this.stringHtml + "</div>";
            } else {
              this.stringHtml =
                "<div class='webpos-print'><div>" +
                res.data.html +
                "</div></div>";
            }
            setTimeout(() => {
              this.printHtml();
            }, 1000);
            this.onePrintOnly = true;
            this.$loading = false;
          } else {
            this.html =
              this.billLogo.data[0].data != "" && this.printSize != "A4"
                ? this.billLogo.img +
                  this.state.billing.billing.return_flow.return_invoice.data
                    .html_data
                : this.state.billing.billing.return_flow.return_invoice.data
                    .html_data;
            this.html =
              this.qrCode.print && this.printSize != "A4"
                ? this.html + this.qrCode.qrImg
                : this.html;
            this.$refs["print-invoice-modal"].show();
          }
        });
      }
    },
    hidePrintModal() {
      this.$refs["print-invoice-modal"].hide();
    },
    printInvoice() {
      let prtContent = document.getElementById("cool");
      // let style = document.createElement("style");
      let WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );
      WinPrint.document.write("<html><head><title>Print Bill</title>");
      if (this.printSize == "A4") {
        WinPrint.document.write(
          this.state.billing.billing.return_flow.return_invoice.data.html_data
            .style
        );
      } else {
        WinPrint.document.write(
          "<style>table{text-align:center}img{width: 150px; height: auto;}</style>"
        );
      }
      WinPrint.document.write("</head><body>");
      WinPrint.document.write("<div>");
      WinPrint.document.write(prtContent.innerHTML);
      WinPrint.document.write("</div>");
      WinPrint.document.write("</body></html>");
      // WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      // WinPrint.close();
    },
    printHtml() {
      // this.$nextTick(() => {
      let billData = [];
      let data = document.querySelectorAll(".webpos-print");
      // console.log(data);
      for (var i = 0; i < data.length; i++) {
        let tempData = data[i].childNodes;
        for (var j = 0; j < tempData.length; j++) {
          billData.push({
            content: tempData[j].textContent,
            size: tempData[j].textContent.length,
          });
        }
      }
      let htmlData = "";
      htmlData = Object.keys(billData)
        .map(function(k) {
          let convert = "";
          if (billData[k].size == 1) {
            convert = billData[k].content;
            convert = convert.toString();
          } else {
            convert = billData[k].content.substr(
              0,
              billData[k].content.length - 1
            );
            convert = convert + "\x0A";
            convert = convert.toString();
          }
          return convert;
        })
        .join("");
      // console.log(htmlData.toString());

      let config = "";
      let centerAlign = "\x1B" + "\x61" + "\x31";
      let oneLineBreak = this.billLogo.data[0].data != "" ? "\x0A" : "";
      let paperCut = !this.qrCode.print ? "\x1D" + "\x56" + "\x30" : "";
      let lineBreak = !this.qrCode.print ? "\x0A" + "\x0A" + "\x0A" : "\x0A";

      let pdata = [];
      if (this.printSize == "A4") {
        var Pixeldata = [
          {
            type: "pixel",
            format: "html",
            flavor: "plain", // or 'plain' if the data is raw HTML
            data:
              "<html><head>" +
              this.state.billing.billing.return_flow.return_invoice.data
                .html_data.style +
              "</head><body>" +
              this.state.billing.billing.return_flow.return_invoice.data
                .html_data.html +
              "</body></html>",
          },
        ];
        config = qz.configs.create(this.state.system.printer, {
          units: "mm",
          margins: 6,
        });
        pdata = Pixeldata;
      } else {
        config = qz.configs.create(this.state.system.printer, {
          units: "mm",
        });
        pdata = [
          centerAlign +
            oneLineBreak +
            htmlData +
            lineBreak +
            lineBreak +
            paperCut,
        ];
      }

      if (this.printSize == "A4" || this.billLogo.data[0].data == "")
        qz.print(config, pdata).then(() => {
          if (this.qrCode.print) qz.print(this.qrCode.config, this.qrCode.data);
        });
      else
        qz.print(this.billLogo.config, this.billLogo.data).then(() =>
          qz.print(config, pdata).then(() => {
            if (this.qrCode.print)
              qz.print(this.qrCode.config, this.qrCode.data);
          })
        );
      // console.log(pdata);
      // let self = this;
      // let printerConfig = {
      //   colorType: "blackwhite",
      //   copies: 1,
      //   margins: "0",
      //   rasterize: "false",
      //   rotation: "0",
      //   scaleContent: "false",
      //   units: "mm"
      // };
      // let config = qz.configs.create(this.state.system.printer, printerConfig);
      // let options = {
      //   language: "ESCP"
      // };
      // let size = 11;
      // // Paper width 8 cm
      // let defaultStyle =
      //   "<style>* { font-size: 10px; font-weight: bold; white-space: pre-wrap; margin:0; padding:0; } table {width:280px;  margin-left: -70px; margin-right:0px;  } pre { white-space: pre-wrap; word-wrap: break-word;  } .center { text-align: center; margin-left:-10px } .left { text-align: left; } .right { text-align: right; } .left pre { padding-left:0px !important; } .right pre { padding-left:0px !important; } tbody { display: table !important; }</style>";
      // if (this.printSize == 58) {
      //   // Paper width 5 cm
      //   size = 10;
      //   defaultStyle =
      //     "<style>* { font-size: 8px; font-weight: bold; white-space: pre-wrap; margin:0; padding:0; } table { width:200px;  margin-left:-70px; margin-right:5px } pre { white-space: pre-wrap; word-wrap: break-word;  } .center { text-align: center; } .left { text-align: left; } .right { text-align: right; } .left pre { padding-left:0px !important; } .right pre { padding-left:15px !important; } tbody { display: table !important; width: inherit; word-wrap: break-word; }</style>";
      // }
      // let data = [
      //   {
      //     type: "raw",
      //     format: "html",
      //     flavor: "plain", // or 'plain' if the data is raw HTML
      //     // data: this.state.billing.invoice.data.html_data,
      //     data: "<html><body>" + defaultStyle + html + "</body></html>"
      //     // data:
      //     //   '<html><body><style>* { font-size: 10px; white-space: pre-wrap; }</style><table style="border:1px solid black"><tr><td style="font-size:13px"><b><pre>Pos Store -1\n</pre></b></td></tr><tr><t d style="font-size:12px"><span><pre>D-3 Phase-II Opp Lajpat Nagar Police Station Cool School\n</pre></span></t></tr></table></body></html>'
      //   }
      // ];
      // // console.log(config);
      // qz.print(config, data)
      //   .then(function() {
      //     console.log("Sent data to printer");
      //     self.printBtn = true;
      //   })
      //   .catch(function(e) {
      //     console.error(e);
      //   });
    },
  },
};
</script>
<style lang="scss" scoped>
.payment-methods {
  height: calc(100vh - 201px) !important;
  img {
    height: 44px;
  }
  label {
    padding-left: 0;
  }
  .text-success {
    color: #33cc66 !important;
  }
}
.btn:hover {
  color: #fff;
}
h6 {
  font-size: 0.8125rem;
  color: #606060;
}
.checkout label {
  color: #808080 !important;
}
.checkout p {
  color: #404040 !important;
}
.theme-dark .checkout p {
  color: #fff !important;
}
.grey-outline-btn {
  border: 1px #808080 solid;
  background-color: transparent !important;
  color: #808080 !important;
  width: 90px;
}
.grey-outline-btn:focus:active {
  border: 1px #808080 solid;
  background-color: #808080 !important;
  color: #fff;
}
.grey-outline-btn:hover {
  border: 1px #808080 solid;
  background-color: #808080 !important;
  color: #fff !important;
}
.grey-btn:hover {
  border: 1px #808080 solid;
}
.grey-btn:active {
  border: 1px #808080 solid;
}
.grey-btn {
  border: 1px #808080 solid;
  padding: 0.675rem 1rem !important;
  color: #fff;
  width: 120px !important;
}
</style>
